(ns ui.animation-editor.transport
  "The requests of the editor to the `/query` and `/command2` endpoints,
   as promises. Not the `:data/query` and `:data/command` actions of
   parts.replicant: the editor loads its entity once and copies it into
   its own state (the query log would keep a copy that is never read
   again), and the save has to report a failed request as well, which
   the `:on-error` of `:data/command` does not cover."
  (:require [parts.replicant.transit :as transit]))

(defn post!
  [{:keys [transit/read-opts transit/write-opts]} url body]
  (-> (js/fetch url
                #js {:method "POST"
                     :body (transit/transit-encode body write-opts)})
      (.then (fn [^js response]
               (if (.-ok response)
                 (.text response)
                 (throw (js/Error. (str "HTTP " (.-status response) " for " url))))))
      (.then (fn [text]
               (transit/transit-decode text read-opts)))))

(defn query!
  "Resolves to the response of the query `q`, a map with `:success?` and
   the `:query/result` as `:result`."
  [w q]
  (post! w "/query" q))

(defn command!
  "Resolves to the response of the `command`, a map with `:success?`."
  [w command]
  (post! w "/command2" command))
